import * as React from "react";
import { SurveyStep } from "../types";

interface DispatchProps {
  goToCovidStep: (step: SurveyStep) => void;
}

type Props = DispatchProps;

class Landing extends React.PureComponent<Props> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      submitDisabled: true
    };
  }

  public continue = () => {
    this.props.goToCovidStep(SurveyStep.AnswerQuestion);
  };

  public render() {
    return (
      <>
        <div className="emergency">
          <div className="big">Call 911 immediately</div>
          if you are experiencing a medical emergency.
          <div className="small">
            Do not rely on communication through this website for urgent medical needs.
          </div>
        </div>

        <div className="body white">
          <div className="pl-5 pr-5">
            <div className="mt-20 mb-10">Thank you for visiting.</div>
            <div className="description">
              This assessment is provided to help understand your situation and get you in contact
              with the appropriate provider. You will be contacted soon as possible, and in an
              attempt to stop the spread of the virus, as remotely as possible.
            </div>
            <div className="mt-30 center">
              <button onClick={() => this.continue()}>Take the COVID-19 Self Assessment</button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Landing;
